module.exports = __webpack_public_path__ + "img/制御工学7_9.f177cf59.png";